"use strict";
/**
 * @file Created on Fri Feb 22 2019
 * @author SKu
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var immutable_1 = require("immutable");

var StructPropBuilder_1 = require("../../core/model/data-dictionary/StructPropBuilder");

var DomainObject_1 = require("../../core/model/DomainObject");
/**
 * Product represents internal product of the company. Some information,
 * such as its name, description, are updated within nighttime imports.
 *
 * @author SKu
 */


var ProductName =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(ProductName, _DomainObject_1$Domai);

  /**
   * Constructs product instance.
   *
   * @param id the internal id of product
   * @param externalId the external id of product, i.e. from source data, is used for pairing during data import
   * @param name
   */
  function ProductName(id, externalId, name) {
    var _this;

    _classCallCheck(this, ProductName);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ProductName).call(this));
    _this.id = id;
    _this.externalId = externalId;
    _this.name = name;
    return _this;
  }

  return ProductName;
}(DomainObject_1.DomainObject);

exports.ProductName = ProductName;
ProductName.EMPTY_LIST = immutable_1.List(); // tslint:disable-next-line:member-ordering

ProductName.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(ProductName.name);
  return {
    id: builder.id('id'),
    externalId: builder.str('externalId'),
    name: builder.str('name')
  };
}();